import { render, staticRenderFns } from "./ptcform.vue?vue&type=template&id=ac666ee8&scoped=true"
import script from "./ptcform.vue?vue&type=script&lang=js"
export * from "./ptcform.vue?vue&type=script&lang=js"
import style0 from "./ptcform.vue?vue&type=style&index=0&id=ac666ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac666ee8",
  null
  
)

export default component.exports